"use client"

import type { ReactNode, Ref, SelectHTMLAttributes } from "react"

import { useFieldA11y, type FieldSize, type FieldState } from "@/components/ui/field"
import { ChevronIcon } from "@/components/ui/icons"

interface SelectProps extends Omit<SelectHTMLAttributes<HTMLSelectElement>, "size"> {
  label?: string
  help?: ReactNode
  state?: FieldState
  size?: FieldSize
  ref?: Ref<HTMLSelectElement>
}

export const Select = ({ label, help, state, size, disabled, className, id, children, ref, ...rest }: SelectProps) => {
  const { fieldId, helpId, styles, controlProps } = useFieldA11y({ id, help, state, size, disabled })
  return (
    <div className={styles.root({ className })}>
      {label && (
        <label htmlFor={fieldId} className={styles.label()}>
          {label}
        </label>
      )}
      <div className={styles.control({ className: "relative flex items-center" })}>
        <select
          ref={ref}
          disabled={disabled}
          {...controlProps}
          className={styles.input({ className: `appearance-none pr-500 ${disabled ? "text-fg-muted cursor-not-allowed" : ""}` })}
          {...rest}
        >
          {children}
        </select>
        <span className="text-fg-subtle pointer-events-none absolute right-3">
          <ChevronIcon size={14} className="rotate-90" />
        </span>
      </div>
      {help && (
        <div id={helpId} className={styles.help()}>
          {help}
        </div>
      )}
    </div>
  )
}
